export const SET_LLM_SERVICE_LIST = 'SET_LLM_SERVICE_LIST';
export const SET_LLM_SERVICE_COUNT = 'SET_LLM_SERVICE_COUNT';
export const SET_LLM_SERVICE_HAS_NEXT = 'SET_LLM_SERVICE_HAS_NEXT';
export const SET_CURRENT_LLM_SERVICE = 'SET_CURRENT_LLM_SERVICE';
export const SET_LLM_RATING_LIST = 'SET_LLM_RATING_LIST';
export const SET_LLM_RATING_COUNT = 'SET_LLM_RATING_COUNT';
export const RESET_CURRENT_LLM_SERVICE = 'RESET_CURRENT_LLM_SERVICE';

export interface LlmDeliveryServiceItem {
  deliveryService: string,
  llmPrompt: string,
  createdAt: string,
  updatedAt: string,
}

export interface LlmDeliveryServiceRatingItem {
  id: number,
  response: string,
  createdAt: string,
  updatedAt: string,
}

export interface SetLlmServiceList {
  type: typeof SET_LLM_SERVICE_LIST,
  payload: Array<LlmDeliveryServiceItem>,
}

export interface SetLlmServiceCount {
  type: typeof SET_LLM_SERVICE_COUNT,
  payload: number,
}

export interface SetLlmServiceHasNext {
  type: typeof SET_LLM_SERVICE_HAS_NEXT,
  payload: boolean,
}

export interface SetCurrentLlmService {
  type: typeof SET_CURRENT_LLM_SERVICE,
  payload: LlmDeliveryServiceItem,
}

export interface SetLlmRatingList {
  type: typeof SET_LLM_RATING_LIST,
  payload: Array<LlmDeliveryServiceRatingItem>,
}

export interface SetLlmRatingCount {
  type: typeof SET_LLM_RATING_COUNT,
  payload: number,
}

export interface ResetCurrentLlmService {
  type: typeof RESET_CURRENT_LLM_SERVICE,
}

export type LlmServiceAction =
  SetLlmServiceList |
  SetLlmServiceCount |
  SetLlmServiceHasNext |
  SetCurrentLlmService |
  SetLlmRatingList |
  SetLlmRatingCount |
  ResetCurrentLlmService;
